import DetailPage from "../components/DetailPage";
import { detailPages } from "../data/detailPages";

export default function ComplexDigitalWorkflows() {
  return <DetailPage data={detailPages["complex-digital-workflows"]} />;
}
